import DataObjectTwoToneIcon from '@mui/icons-material/DataObjectTwoTone'
import { Button, Grid, useMediaQuery } from '@mui/material'
import Step from '@mui/material/Step'
import StepButton from '@mui/material/StepButton'
import Stepper from '@mui/material/Stepper'
import { keyframes } from '@emotion/react'
import { useEffect } from 'react'

import { useDispatch } from 'react-redux'
import { useLocation, useNavigate } from 'react-router-dom'
import { snackActions } from './SnackbarUtilsConfigurator'
import { useAppSelector } from './app/hooks'
import { useGetCfQuery } from './features/ricerca/ricercaAPI'
import {
    CfNewObj,
    SETUP_VERSION_NUMBER,
    selectFullScreen,
    selectVersion,
    setFullScreen,
    setIsUpdate,
} from './features/ricerca/ricercaSlice'

const orangeHalo = keyframes`
  0%   { border-radius: 62% 38% 46% 54% / 44% 57% 43% 56%; box-shadow: 0 0 5px 12px rgba(220,0,0,0.85), 0 0 8px 18px rgba(195,0,0,0.55), 0 0 12px 24px rgba(160,0,0,0.28); }
  25%  { border-radius: 41% 59% 60% 40% / 58% 35% 65% 42%; box-shadow: 0 0 5px 12px rgba(220,0,0,0.85), 0 0 8px 18px rgba(195,0,0,0.55), 0 0 12px 24px rgba(160,0,0,0.28); }
  50%  { border-radius: 55% 45% 35% 65% / 60% 44% 56% 40%; box-shadow: 0 0 6px 14px rgba(220,0,0,0.95), 0 0 10px 21px rgba(195,0,0,0.62), 0 0 14px 28px rgba(160,0,0,0.34); }
  75%  { border-radius: 38% 62% 56% 44% / 42% 60% 40% 58%; box-shadow: 0 0 5px 12px rgba(220,0,0,0.85), 0 0 8px 18px rgba(195,0,0,0.55), 0 0 12px 24px rgba(160,0,0,0.28); }
  100% { border-radius: 62% 38% 46% 54% / 44% 57% 43% 56%; box-shadow: 0 0 5px 12px rgba(220,0,0,0.85), 0 0 8px 18px rgba(195,0,0,0.55), 0 0 12px 24px rgba(160,0,0,0.28); }
`

export default function BreadCrumbsCliccable() {
    const { data: cfData } = useGetCfQuery()

    let fullscreen = useAppSelector(selectFullScreen)

    const cf: CfNewObj | null = cfData != null ? cfData?.data.cf : null

    const location = useLocation()

    const navigate = useNavigate()

    let defaultStep

    if (cf?.cfCliUser.FLAG_WEB_OFFERTE != 1) {
        switch (location.pathname) {
            case '/':
                defaultStep = 0
                break
            case '/carrello':
                defaultStep = 1
                fullscreen = false
                break
            case '/destinazione':
                defaultStep = 2
                fullscreen = false
                break
            case '/fatta':
                defaultStep = 3
                fullscreen = false
                break
        }
    } else {
        switch (location.pathname) {
            case '/':
                defaultStep = 0
                break
            case '/offerte':
                defaultStep = 1
                break
            case '/carrello':
                defaultStep = 2
                fullscreen = false
                break
            case '/destinazione':
                defaultStep = 3
                fullscreen = false
                break
            case '/fatta':
                defaultStep = 4
                fullscreen = false
                break
        }
    }

    const handleStep = (step: number) => () => {
        if (cf?.cfCliUser.FLAG_WEB_OFFERTE != 1) {
            switch (step) {
                case 0:
                    navigate('/')
                    break
                case 1:
                    navigate('/carrello')
                    break
                case 2:
                    navigate('/destinazione')
                    break
                case 3:
                    snackActions.warning(
                        "Non dire 😼 se non ce l'hai nel sacco. Verifica di aver aggiunto qualcosa nel carrello e indica l'ora e il luogo di consegna!!!"
                    )
                    // non è a caso vuoto... serve evitare il click - vi vado dalla response dell'ordine
                    break
                default:
                    navigate('/')
            }
        } else {
            switch (step) {
                case 0:
                    navigate('/')
                    break
                case 1:
                    navigate('/offerte')
                    break
                case 2:
                    navigate('/carrello')
                    break
                case 3:
                    navigate('/destinazione')
                    break
                case 4:
                    snackActions.warning(
                        "Non dire 😼 se non ce l'hai nel sacco. Verifica di aver aggiunto qualcosa nel carrello e indica l'ora e il luogo di consegna!!!"
                    )
                    // non è a caso vuoto... serve evitare il click - vi vado dalla response dell'ordine
                    break
                default:
                    navigate('/')
            }
        }
    }

    const isXs = useMediaQuery((theme: any) => theme.breakpoints.only('xs'))

    const version = useAppSelector(selectVersion)

    const remoteVersionNumber = cfData?.data?.VERSIONE || SETUP_VERSION_NUMBER

    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(setFullScreen(false))
    }, [location])

    return fullscreen == false && defaultStep != null ? (
        <>
            <Stepper nonLinear activeStep={defaultStep} alternativeLabel={isXs}>
                <Step key="Catalogo 🏁">
                    <StepButton color="inherit" onClick={handleStep(0)}>Catalogo 🏁</StepButton>
                </Step>
                {cf?.cfCliUser.FLAG_WEB_OFFERTE == 1 && (
                    <Step key="Offerte 👀">
                        <StepButton
                            color="inherit"
                            onClick={handleStep(1)}
                            sx={{
                                '& .MuiStepLabel-label': {
                                    color: 'black',
                                    fontWeight: 'bold',
                                },
                                ...(defaultStep !== 1 && {
                                    '& .MuiStepIcon-root': {
                                        borderRadius: '50%',
                                        animation: `${orangeHalo} 1s linear infinite`,
                                    },
                                }),
                            }}
                        >
                            OFFERTE 👀
                        </StepButton>
                    </Step>
                )}
                <Step key="Riepiloga 🤓">
                    <StepButton color="inherit" onClick={handleStep(cf?.cfCliUser.FLAG_WEB_OFFERTE == 1 ? 2 : 1)}>Riepiloga 🤓</StepButton>
                </Step>
                <Step key="Consegna ⤴️">
                    <StepButton color="inherit" onClick={handleStep(cf?.cfCliUser.FLAG_WEB_OFFERTE == 1 ? 3 : 2)}>Consegna ⤴️</StepButton>
                </Step>
                <Step key="Fatta 🎉">
                    <StepButton color="inherit" onClick={handleStep(cf?.cfCliUser.FLAG_WEB_OFFERTE == 1 ? 4 : 3)}>Fatta 🎉</StepButton>
                </Step>
            </Stepper>
            {remoteVersionNumber != version.vNumber &&
                (remoteVersionNumber != SETUP_VERSION_NUMBER && (
                    <Grid item xs={12} textAlign="center">
                        <Button
                            sx={{ m: 2 }}
                            color="error"
                            size="large"
                            variant="contained"
                            startIcon={<>🔄</>}
                            onClick={() => {
                                dispatch(setIsUpdate({ vNumber: remoteVersionNumber }))
                            }}
                        >
                            {`Aggiornamento necessario ${remoteVersionNumber}`}
                        </Button>
                    </Grid>
                ))}
        </>
    ) : (
        <></>
    )
}
